/*
 * PAWFEEDER product recommendations.
 *
 * The recommendations object is empty during the server render: Shopify only
 * fills it when the section is rendered through the Product Recommendations
 * API. So the section ships a data-url aimed at its own section id and this
 * runtime asks for it a second time, once the rail is close to the viewport,
 * then swaps in the official recommendations.
 *
 * The server render is never replaced by nothing. Liquid owns the fallback
 * tiers, so the rail is already populated when this script runs. When the
 * request fails, or the response carries no card, the Liquid cards stay exactly
 * as they are and a shell that was waiting for recommendations stays hidden.
 * A catalogue that cannot produce recommendations therefore loses nothing: it
 * never trades a populated rail for an empty heading.
 */
(function () {
  'use strict';

  var host = document.querySelector('[data-pf-reco][data-url]');
  if (!host) return;

  var url = host.getAttribute('data-url');
  if (!url) return;

  var shell = host.closest('[data-pf-reco-section]');

  function swap(html) {
    var parsed = null;
    try {
      parsed = new DOMParser().parseFromString(html, 'text/html');
    } catch (error) {
      return;
    }
    if (!parsed) return;

    var fresh = parsed.querySelector('[data-pf-reco]');
    /* The response is also produced by this section, so an empty set renders
     * its own shell. Only a real card may replace what Liquid already drew. */
    if (!fresh || !fresh.querySelector('.pf-product-card')) return;

    host.innerHTML = fresh.innerHTML;
    if (shell && shell.hidden) shell.hidden = false;
  }

  function load() {
    if (typeof window.fetch !== 'function') return;
    window.fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(swap)
      .catch(function () { /* keep the fallback rail */ });
  }

  if (typeof window.IntersectionObserver === 'function') {
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      load();
    }, { rootMargin: '200px 0px' });
    observer.observe(host);
  } else {
    load();
  }
})();
